<template>
  <div id="basic-switch-wrapper">
    <p
      class="before-text"
      v-if="beforeText"
      ref="beforeText"
      @click="basicSwitch = false"
    >
      {{ beforeText }}
    </p>
    <label class="toggle-control">
      <input type="checkbox" v-model="basicSwitch" />
      <span class="control"></span>
    </label>
    <p
      class="after-text"
      v-if="afterText"
      ref="afterText"
      @click="basicSwitch = true"
    >
      {{ afterText }}
    </p>
  </div>
</template>

<script>
export default {
  name: "BasicSwitch",
  props: {
    fontSize: {
      type: String,
      required: false,
      default: "14px"
    },
    beforeText: {
      type: String,
      required: false,
      default: ""
    },
    afterText: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      basicSwitch: this.value
    };
  },
  mounted() {
    this.initSwitchText();
    if (this.beforeText) {
      this.$refs["beforeText"].style["font-size"] = this.fontSize;
    }
    if (this.afterText) {
      this.$refs["afterText"].style["font-size"] = this.fontSize;
    }
  },
  methods: {
    initSwitchText() {
      if (this.basicSwitch) {
        if (this.beforeText) {
          this.$refs["beforeText"].classList.add("active");
        }
        if (this.beforeText) {
          this.$refs["afterText"].classList.add("active");
        }
      } else {
        if (this.beforeText) {
          this.$refs["beforeText"].classList.remove("active");
        }
        if (this.beforeText) {
          this.$refs["afterText"].classList.remove("active");
        }
      }
    }
  },
  watch: {
    basicSwitch() {
      this.initSwitchText();
      this.$emit("input", this.basicSwitch);
    },
    value() {
      this.basicSwitch = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#basic-switch-wrapper {
  display: flex;
  align-items: center;
  .before-text {
    margin-right: 10px;
    text-align: right;
    cursor: pointer;
    &.active {
      color: $color-primary;
    }
  }
  .after-text {
    margin-left: 10px;
    cursor: pointer;
    &.active {
      color: $color-primary;
    }
  }
}
$toggle-background-color-on: $color-primary;
$toggle-background-color-off: darkgray;
$toggle-control-color: white;
$toggle-width: 50px;
$toggle-height: 25px;
$toggle-gutter: 5px;
$toggle-radius: 50%;
$toggle-control-speed: 0.3s;
$toggle-control-ease: ease-in;

// These are our computed variables
// change at your own risk.
$toggle-radius: $toggle-height / 2;
$toggle-control-size: $toggle-height - ($toggle-gutter * 2);

.toggle-control {
  display: block;
  position: relative;
  padding-left: $toggle-width;
  height: $toggle-height;
  cursor: pointer;
  font-size: 22px;
  user-select: none;
  margin-bottom: 0 !important;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked ~ .control {
    background-color: $toggle-background-color-on;

    &:after {
      left: $toggle-width - $toggle-control-size - $toggle-gutter;
    }
  }

  .control {
    position: absolute;
    top: 0;
    left: 0;
    height: $toggle-height;
    width: $toggle-width;
    border-radius: $toggle-radius;
    background-color: $toggle-background-color-off;
    transition: background-color $toggle-control-speed $toggle-control-ease;

    &:after {
      content: "";
      position: absolute;
      left: $toggle-gutter;
      top: $toggle-gutter;
      width: $toggle-control-size;
      height: $toggle-control-size;
      border-radius: $toggle-radius;
      background: $toggle-control-color;
      transition: left $toggle-control-speed $toggle-control-ease;
    }
  }
}
</style>
